<template>
  <div class="container">
    <template v-if="multiCharge == 0 || multiCharge == 3">
      <div class="card-multiple-charge container-flex">
        <div class="input-container">
          <div
            class="van-cell van-field"
          >
            <textarea
              class="input-textarea"
              placeholder="请输入您的申请理由"
              maxlength="200"
              v-model="applyReason"
            />
          </div>
        </div>
        <div class="tips-text">
          该功能支持多台车辆同时充电， 使用时请确保您的账户余额充足。
        </div>

        <div class="error-text" v-if="multiCharge == 3">
          申请已拒绝，请完整描述你的使用场景
        </div>
      </div>
      <div class="btn-box">
        <pi-button type="primary" block @click="subData">提交申请 </pi-button>
      </div>
    </template>
    <div class="one-success" v-if="multiCharge == 1">
      <img src="../../picture/no-data-icon/success.png" class="success-icon" />
      <div class="one-success-text">一号多充服务已开通</div>
    </div>
    <div class="one-success" v-if="multiCharge === 2">
      <img src="../../picture/no-data-icon/success.png" class="success-icon" />
      <div class="one-success-text">提交成功，请等待管理员审核</div>
    </div>
  </div>
</template>
<script>
import { Field } from "vant";
import { applyMultiCharge, getUserBaseInfo } from "../../common/api";
export default {
  name: "pi-card-multiple-charge",
  components: {
    [Field.name]: Field,
  },
  data() {
    return {
      applyReason: "",
      multiCharge: 0, // 0: "未开通",1: "已开通",2: "申请中",3: "已拒绝，再次申请",
    };
  },
  mounted() {
    this.getUserBaseInfo();
  },
  methods: {
    async getUserBaseInfo() {
      let ret = await getUserBaseInfo({}, { loading: false });
      if (ret.status === 0) {
        let data = ret.data[0] || {};
        this.multiCharge = data.multiCharge;
      }
    },
    subData() {
      if (this.applyReason == "") {
        this.$toast("请输入申请理由");
      } else {
        applyMultiCharge(
          {
            applyReason: this.applyReason,
          },
          true
        ).then((response) => {
          if (response.status == this.$config.ajaxStatus) {
            this.$toast("提交成功");
            window.history.go(-1);
          } else {
            this.$toast(response.msg);
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
/* pages/one-to-more/one-to-more.wxss */

.card-multiple-charge {
  padding: 0.25rem;
}
.card-multiple-charge .input-container {
  height: 3.16rem;
  padding-bottom: 0.25rem;
  border-bottom: 1px solid #d6d6d6;
}
.van-cell {
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 3.16rem;
  padding: 0.10rem 0.16rem;
  overflow: hidden;
  color: #323233;
  font-size: 0.14rem;
  line-height: 0.24rem;
  background-color: #fff;
}
.input-textarea {
  height: 3.16rem;
  font-size: 0.28rem;
  font-weight: 400;
  color: #999999;
  line-height: 0.40rem;
  width: 100%;
}
.card-multiple-charge .tips-text {
  background-color: #ffd298;
  padding: 0.10rem 0.38rem;
  font-size: 0.21rem;
  line-height: 0.29rem;
  color: #999;
  text-align: center;
  margin-top: 0.20rem;
}
.btn-box {
  margin: 0.30rem;
}

.one-success {
  padding-top: 0.59rem;
  text-align: center;
}
.one-success .success-icon {
  width: 2.50rem;
  height: 2.50rem;
  margin: auto;
}
.one-success .one-success-text {
  font-size: 0.28rem;
  line-height: 0.40rem;
  margin-top: 0.20rem;
}
.error-text {
  color: #e74528;
  font-size: 0.28rem;
  line-height: 0.40rem;
  margin-top: 0.60rem;
  text-align: center;
}
</style>